///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, pricesManagerByArticleActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getPriceArticles = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_PRICES_ARTICLE(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(pricesManagerByArticleActionCreators.getPriceArticlesSuccess(data.data))
		yield put(globalLoadingActionCreators.endLoading())
	} catch (e) {
		yield put(globalLoadingActionCreators.endLoading())

		yield put(errorManagerActionCreators.createError(e.response))

		yield put(pricesManagerByArticleActionCreators.getPriceArticlesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
	put(globalLoadingActionCreators.endLoading())
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_PRICES_ARTICLE, getPriceArticles)
}

export default sagas
